import { trigger, state, style, group, animate, transition, keyframes } from '@angular/animations';

export function slideLeftAnimation(distance = 100, time = 0.2) {
  return trigger('slideLeftAnimation', [
    state('false', style({ transform: `translateX(-${distance}%)`, opacity: 0, display: 'none' })),
    transition('0 => 1', group(
      [
        style({display: 'block'}),
        animate(`${time}s ease-out`, style({
          transform: 'translateX(0)',
          opacity: 1
        }))
      ]
    )),
    transition('1 => 0', group(
      [
        animate(`${time}s ease-out`, style({
          transform: `translateX(-${distance}%)`,
          opacity: 0
        }))
      ]
    ))
  ]);
}



// WEBPACK FOOTER //
// ./src/app/shared/animations/slide-left.animation.ts